<template>
  <div class="w-full">
    <!-- <pre>
     users {{ users }}
    </pre> -->
    <div>
      {{ $route.meta.title }}
    </div>
    <div class="flex justify-end">
      <v-btn @click="onPressAdd" small>Add</v-btn>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="loading"
        :search="search"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small @click="edit(item)">
            <v-icon small> mdi-pencil </v-icon>
            Edit
          </v-btn>

          <v-btn small @click="del(item)"
            ><v-icon small> mdi-delete </v-icon> Delete</v-btn
          >
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="addDialog"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <div class="bg-white">
        <AddComponent @cancelAddDialog="cancelAdd" />
      </div>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="300px"
      transition="dialog-transition"
    >
      <DeleteComponent @cancelDelete="cancelDelete" :deleteInfo="deleteInfo" />
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <EditComponent @cancelEdit="cancelEdit" />
    </v-dialog>
    <v-snackbar top v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import AddComponent from "../../settingsScreen/UserSettingsScreen/components/Add.vue";
import EditComponent from "../../settingsScreen/UserSettingsScreen/components/Edit.vue";
import DeleteComponent from "../../settingsScreen/UserSettingsScreen/components/Delete.vue";
import Axios from "axios";
import EventBus from "@/EventBus";

export default {
  data() {
    return {
      deleteInfo: {},
      snackbarMessage: null,
      snackbar: false,
      loading: false,
      addDialog: false,
      editDialog: false,
      deleteDialog: false,
      search: null,
      users: [],
      headers: [
        {
          text: "Full Name",
          value: "fullname",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Password",
          value: "password",
        },
        {
          text: "Department",
          value: "department",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
    };
  },

  components: { AddComponent, EditComponent, DeleteComponent },
  mounted() {
    // this.getMyRoleId();
    this.getUsers();
    EventBus.$on("refreshUsers", (action) => {
      this.getUsers();
      this.addDialog = false;
      this.deleteDialog = false;
      this.snackbarMessage = `Successfully ${action} a new user!`;
      this.snackbar = true;
    });
  },
  beforeDestroy() {
    EventBus.$off("refreshUsers");
  },
  methods: {
    getUsers() {
      Axios.get("/users").then((res) => {
        this.users = res.data.output.filter((x) => x.email !== "arty@tanco.us");
      });
    },
    cancelDelete() {
      this.deleteDialog = false;
    },
    cancelEdit() {
      this.editDialog = false;
    },
    edit() {
      this.editDialog = true;
    },
    del(item) {
      this.deleteDialog = true;
      this.deleteInfo = item;
    },
    cancelAdd() {
      this.addDialog = false;
    },
    onPressAdd() {
      this.addDialog = true;
    },
  },
};
</script>
